export type GiftCertificateAPIResponse = {
  id?: string;
  balance?: string;
};

export type GiftCertificate = {
  id: string;
  balance: number;
};
